module.exports = prestashop;


//////////////////
// WEBPACK FOOTER
// external "prestashop"
// module id = 48
// module chunks = 0